import { render, staticRenderFns } from "./ProductRatingCard.vue?vue&type=template&id=64919d84"
import script from "./ProductRatingCard.vue?vue&type=script&lang=js"
export * from "./ProductRatingCard.vue?vue&type=script&lang=js"
import style0 from "./ProductRatingCard.vue?vue&type=style&index=0&id=64919d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports